import { FlexLayout, H4 } from '@deity/falcon-ui';
import KeyValueTable, { KeyValidators } from 'components/FieldEditorControls/KeyValueTable';
import type { FC } from 'react';

interface HTTPHeadersProps {
  isEditable: boolean;
  headers: Record<string, string>;
  onChange: (key: string[], val: {}, set?: boolean) => void;
}
const HTTPHeaders: FC<HTTPHeadersProps> = ({ isEditable, headers, onChange }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 mb="xs" fontWeight="semiBold" fontSize="xl">
      Headers
    </H4>
    <KeyValueTable
      key="headers"
      isEditable={isEditable}
      keyValidator={KeyValidators.IS_VALID_HEADER_NAME}
      persistedValue={headers}
      onTableValueChange={(key, val) => onChange(['headers'], val)}
    />
  </FlexLayout>
);

export default HTTPHeaders;
